import types from '../actions/types';
// DATA
import copper from 'data/copper';
import fiberR1 from 'data/fiber-r1';
import fiberR2 from 'data/fiber-r2';
import citiesWithFiber from 'data/cities-with-fiber';
// SELECTORS
import * as selectors from './byside.selectors';

const initialState = {
  lists: {
    copper,
    fiberR1,
    fiberR2,
    citiesWithFiber
  },
  ui: {
    product: {
      plan: null,
      productOrigin: null,
      headline: "Central de Vendas da Oi",
      greeting: "",
      title: "",
      subtitle: "",
      features: []
    },
  },
};

const bysideReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case types.LOAD_PRODUCT:
      return {
        ...state,
        ui: {
          ...state.ui,
          product: { ...state.ui.product, ...selectors.selectProduct(state, payload) } || { ...state.ui.product, plan: payload.plan, productOrigin: payload.productOrigin }
        }
      };
    default:
      return state;
  }
};

export default bysideReducer;
